<template>
	<div>
        <v-card id="videoFrontCard" elevation="5" class="pa-4">
            <div>
                <v-btn
                    fab
                    x-small
                    color="red"
                    outlined
                    @click="updateValue(true)"
                >
                    <v-icon> mdi-axis-z-rotate-clockwise </v-icon>
                </v-btn>
            </div>
            <div
                :style="
                    $vuetify.breakpoint.smAndDown
                        ? 'height: 420px; align-items: center'
                        : 'height: 370px; align-items: center'
                "
                class="d-flex justify-center flex-column"
                align="center"
            >
                <v-icon id="youtubeIcon" size="200" color="red">mdi-youtube</v-icon>
                <v-icon id="backSquare" size="200" color="grey lighten-3">mdi-square-rounded</v-icon>
                <h2
                    :class="
                        $vuetify.breakpoint.mdAndDown
                            ? 'overline'
                            : 'display-3 font-weight-normal'
                    "
                >
                    {{ capitalize(video.title) }}
                </h2>
            </div>
        </v-card>
	</div>
</template>


<script>
export default {
	name: 'VideoFrontCard',
	props: {
		video: Object,
	},
	data: () => ({
	}),
	methods: {
		updateValue: function (value) {
			this.$emit('input', value);
		},
		capitalize(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
	},
	computed: {},
};
</script>


<style>
#videoFrontCard {
    transition: 0.7s;
    transform: scale(1);
}
    
#videoFrontCard:hover {
    transition: 0.7s;
    transform: scale(1.07);
}

#videoFrontCard:hover #backSquare {
    transition: ease-in-out 1.5s;
    transform: rotate(360deg);
}

#youtubeIcon {
    transition: ease-in-out 1.5s;
    transform: rotate(0deg);
    /*overlay over all components*/
    z-index: 1 !important;
}

#backSquare{
    position: relative;
    top: -54%;
    transition: ease-in-out 1.5s;
    transform: rotate(0deg);
    margin-bottom: -24%;
}

@media screen and (max-width: 900px) {
    #backSquare {
        margin-top: 3.9999%;
    }
}

@media screen and (max-width: 600px) {
    #backSquare {
        margin-top: 9%;
    }
}

</style>